/*
  2020-08-11
  - Are you sure that the json report is modified in the backend on handleDelete?
*/

import { API, Auth } from 'aws-amplify'
import React, { useEffect, useState } from 'react'
import { Table, TableCell, TableHead, TableRow } from '@aws-amplify/ui-react';
import QuerySerachReportRow from './QuerySerachReportsRow';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { Link } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Spinner from 'react-bootstrap/Spinner';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';
import { downloadfile } from '../../utils/utils';


const QuerySerachReportTable = (props) => {
  const search_id = props.search_id
  const new_report = props.new_report
  const [Querys, setQuerys] = useState('')
  const [OtherAnswers, setOtherAnswers] = useState(null)
  const [response, setResponse] = useState(null);
  const [isBusy, setIsBusy] = useState(false);
  const [reportname, setReportname] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [top_answer_text, setTopAnswerText] = useState('');

  //Function to fetch from our backend and update customers array
  const getsearches = async () => {
    setIsBusy(true);
    const user = await Auth.currentAuthenticatedUser()
    const token = user.signInUserSession.idToken.jwtToken
    const requestInfo = { headers: { Authorization: token } }
    let api_params = "/getsavedsearch?reportid=" + search_id
    if (new_report == 'true')
      api_params += "&create=true"

    API.get("DocumentSearchUser", api_params, requestInfo)
      .then(response => {
        setIsBusy(false);
        console.log('inside getsearches');
        console.log(response);
        setOtherAnswers(response.items.other_answers)
        console.log(OtherAnswers)
        setResponse(response);
        // setQuerys(response.Query.join(', '));
        setReportname(response.report_name)
        if(response?.items?.top_answer == undefined)
        {
          setTopAnswerText('');
        }
        else
        {
          setTopAnswerText('Best Answer');
        }
      })
      .catch(error => {
        setIsBusy(false);
        console.log(error)
      })
  };
  
  useEffect(() => { getsearches() }, [])

  const handleSelect = (entity) => {
    console.log('selected ' + entity.id)
    // API.get('DocumentSearchUser', '/deleteproject' + `?userid=${entity.user_id}&projectid=${entity.project_id}`)
    //    .then(response => {
    //      //console.log(response)
    //      getProjects();

    //    })
    //    .catch(error => {
    //      console.log(error)
    //    })
  };
  
  const handleDelete = async (entity) => {
    setIsBusy(true);
    const user = await Auth.currentAuthenticatedUser()
    const token = user.signInUserSession.idToken.jwtToken
    const requestInfo = { headers: { Authorization: token } }
    /* Code Here */
    console.log('inside handleDelete')
    console.log(response)
    API.get("DocumentSearchUser", `/deletereportitem?reportid=${search_id}&entityid=${entity.id}`, requestInfo)
      .then(res => {
        setIsBusy(false);
        let index = OtherAnswers.indexOf(entity)
        if (index >= 0) {
          let newOtherAnswers = [...OtherAnswers]
          newOtherAnswers.splice(index,1)
          setOtherAnswers(newOtherAnswers)
        }
      })
      .catch(error => {
        setIsBusy(false);
        console.log(error)
      })
    
    // console.log("Querys")
    
    // console.log('entity')
    // console.log(entity)
    
    // console.log('query id :  ')
    // console.log(entity.id)
    
    // console.log('search id :  ')
    // console.log(search_id)
    
    // console.log('querys :  ')
    // console.log(Querys)
    
    
    setIsBusy(false)
    
    /* --------- */
  };
  
  const renameReport = async (name) => {
    setIsBusy(true);
    const user = await Auth.currentAuthenticatedUser()
    const token = user.signInUserSession.idToken.jwtToken
    const requestInfo = { headers: { Authorization: token } }
    console.log(name, name.input)
    API.get('DocumentSearchUser', '/namereport' + `?reportid=${search_id}&name=${name.reportname}`, requestInfo)
      .then(response => {
        setIsBusy(false);
        setErrorMessage('');
      })
      .catch(error => {
        setIsBusy(false);
        console.log(error)
        if (error.response.status == 406) {
          setErrorMessage('A report with the same name already exists!');
        }
      })
  };
  
  return (
    <>
      <Row>
        <Col>
          <br />
          <Breadcrumb>
            <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>Home</Breadcrumb.Item>
            <Breadcrumb.Item active>Query Search Report</Breadcrumb.Item>
          </Breadcrumb>
        </Col>
      </Row>
      <Row>
        <Col>
          <h1 style={{ textAlign: 'center' }}>Query Search Report</h1>
        </Col>
      </Row>
      <Row>
        <Col style={{ textAlign: 'initial' }}>
          <InputGroup className="mb-3">
            <InputGroup.Text>Report Name:</InputGroup.Text>
            <FormControl
              placeholder="enter new report name"
              aria-label=""
              aria-describedby="basic-addon2"
              value={reportname} onChange={(e) => setReportname(e.target.value)}
            />
            <Button variant="outline-secondary" id="button-addon2" onClick={() => renameReport({ reportname })}>
              {/* <PlusLg /> */}Rename
            </Button>
          </InputGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          {isBusy &&
            <Spinner animation="border" role="status" variant="primary">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          }
        </Col>
      </Row>
      <Row>
        <Col>

          {errorMessage && (
            <Alert key="danger" variant="danger">
              {errorMessage}
            </Alert>
          )}</Col>
      </Row>
      <Row>
        <Col>
        
     <h3>{top_answer_text}</h3>

        <a className='App-link text-center' onClick={() => downloadfile(response.project_id, response?.items?.top_answer?.document)}>{response?.items?.top_answer?.document}</a>
        <p dangerouslySetInnerHTML={{ __html: response?.items?.top_answer?.highlight }}>
        </p>
        <h3>Answers</h3>
        </Col>
      </Row>
      <Row>
        <Col>
          <Table className='table table-striped' >
            <TableHead className='thead-dark' style={{ textAlign: 'center' }}>
              <TableRow>
                <TableCell><strong>#</strong></TableCell>
                <TableCell><strong>Document Name</strong></TableCell>
                <TableCell><strong>Page</strong></TableCell>
                <TableCell><strong>Text</strong></TableCell>
                <TableCell style={{ width: "100px" }}><strong>  </strong></TableCell>
                <TableCell><strong>  </strong></TableCell>
              </TableRow>
            </TableHead>
            <tbody>
              {
                OtherAnswers?.map((thisEntity, index) => {
                  return (
                    <QuerySerachReportRow key={thisEntity.id} projectid={response.project_id} index={index} onDelete={handleDelete} entity={thisEntity} Querys={Querys} onSelect={handleSelect} />
                  )
                })
              }
            </tbody>
          </Table>
        </Col>
      </Row>
    </>
  )
}


export default QuerySerachReportTable;